import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectSettingsScreensAssociateRoute: InvariantJiraRoute = {
	name: 'legacy-project-settings-screens-associate',
	path: '/secure/project/SelectIssueTypeScreenScheme!default.jspa',
};
